/* eslint-disable no-console */
import provider from './provider';

import {
	LOADING_STATES,
} from './const';


// module
export default {
	namespaced: true,

	state: () => ({
		// loading
		loadingState: { type: LOADING_STATES.LOADING, progress: 0 },
		wizardConfigJSON: null,
		threeAppConfigJSON: null,
		objectsStateJSON: null,

		stepIndex: 0, // current step index

		paddings: { top: 0, bottom: { stepPanel: 0, editPanel: 0 }}, // paddings for panel

		isMobileLandscape: false,
	}),

	mutations: {
		/**
		 * Restore virginity
		 * @param state
		 */
		reset(state) {
			state.loadingState = { type: LOADING_STATES.LOADING, progress: 0 };
			state.wizardConfigJSON = null;
			state.threeAppConfigJSON = null;
			state.objectsState = null;

			state.stepIndex = 0; // current step index

			state.paddings = { top: 0, bottom: { stepPanel: 0, editPanel: 0 }}; // paddings for panel

			state.isMobileLandscape = false;
		},

		/**
		 * @param {object} state - module state
		 * @param {object} payload
		 * @param {string} payload.type
		 * @param {number} payload.progress
		 *
		 * @example payload = { type: 'loading', progress: 0}
		 */
		setLoadingState: (state, payload) => { state.loadingState = payload; },

		setWizardConfigJSON: (state, payload) => { state.wizardConfigJSON = payload; },
		setThreeAppConfigJSON: (state, payload) => { state.threeAppConfigJSON = payload; },

		setObjectsStateJSON: (state, payload) => { state.objectsStateJSON = payload; },

		setStepIndex: (state, payload) => {
			state.stepIndex = +payload;

			// close panel on step change
			state.isEditMode = false;
		},

		setPaddings(state, payload) {
			// example payload { stepPanel: 100 } or {editPanel: 100} or {top: 200}
			if (payload?.stepPanel !== undefined) {
				state.paddings.bottom.stepPanel = payload?.stepPanel;
			}
			if (payload?.editPanel !== undefined) {
				state.paddings.bottom.editPanel = payload?.editPanel;
			}
			if (payload?.top !== undefined) {
				state.paddings.top = payload?.top;
			}
		},

		setMobileLandscape(state, payload) {
			state.isMobileLandscape = payload;
		},
	},


	getters: {
		// the application loading
		loadingState: ({ loadingState }) => loadingState,

		wizardConfig: ({ wizardConfigJSON }) => wizardConfigJSON && JSON.parse(wizardConfigJSON),
		threeAppConfig: ({ threeAppConfigJSON }) => threeAppConfigJSON && JSON.parse(threeAppConfigJSON),
		objectsState: ({ objectsStateJSON }) => objectsStateJSON && JSON.parse(objectsStateJSON),

		stepIndex: ({ stepIndex }) => stepIndex,

		currentStep: (state, getters) => getters.wizardConfig?.[getters.stepIndex] || null,

		// panels
		paddings: ({ paddings }) => paddings,

		isMobileLandscape: ({ isMobileLandscape }) => isMobileLandscape,
	},

	actions: {
		async fetchData({
			commit,
		}) {
			// eslint-disable-next-line import/no-absolute-path, import/no-unresolved
			const customizerConfig = await import('@/assets/customizer/config/config.js');

			const {
				threeAppOptions, initialState, wizardOptions,
			} = customizerConfig;

			// save all the stuff
			commit('setWizardConfigJSON', JSON.stringify(wizardOptions));
			commit('setThreeAppConfigJSON', JSON.stringify(threeAppOptions));
			commit('setObjectsStateJSON', JSON.stringify(initialState));
		},


		focus({ getters }, {
			object, area, place, options,
		} = {}) {
			const { duration = 0.5 } = options || {};

			const result = provider.app.focusOn({ object, area, place }, options);
			if (result instanceof Promise) {
				return result;
			}

			return new Promise((resolve) => { setTimeout(() => resolve(result), duration * 1000); });
		},


		// a bunch of treeApp handlers
		handleFocus({ commit, getters, dispatch }, payload) {
			// console.info('tagdog/handleFocus', payload);
			const { area, object } = payload;

			if (getters.isEditMode === 'text') {
				// dispatch('focus', getters.steps[getters.stepIndex]); // it cause ios crash handle. we need emit this click to textEditor
				return;
			}

			let stepIndex = getters.steps.findIndex(({ target }) => target.area && (area === target.area));
			if (stepIndex === -1) {
				stepIndex = getters.steps.findIndex(({ target }) => object === target.object);
			}
			if (stepIndex === -1) {
				return;
			}
			commit('setStepIndex', stepIndex);
		},

		updatePaddings({ getters, commit }, payload) {
			// console.info('tagdog/updatePaddings', payload);

			if (getters.isMobileLandscape) {
				provider.app?.setPanelsSize({ top: 0, bottom: 0 }, false);
				return;
			}

			commit('setPaddings', payload);

			if (getters.isEditMode && payload.editPanel !== undefined) {
				provider.app?.setPanelsSize({ top: getters.paddings.top, bottom: getters.paddings.bottom.editPanel }, true);
				return;
			}

			if (payload.stepPanel !== undefined || payload.top !== undefined) {
				provider.app?.setPanelsSize({ top: getters.paddings.top, bottom: getters.paddings.bottom.stepPanel }, true);
			}
		},

		async initThreeApp({ getters }) {
			// payload is threeApp itself
			await provider.app.init();
			provider.app?.setPanelsSize({ top: getters.paddings.top, bottom: getters.paddings.bottom.stepPanel }, false);
		},

		async updateObjectsState({ commit, getters, dispatch }, payload) {
			const currentState = JSON.parse(JSON.stringify(getters.objectsState));

			const objectIndex = currentState.findIndex((object) => object.id === payload.id);

			currentState[objectIndex] = { ...currentState[objectIndex], ...payload };

			commit('setObjectsStateJSON', JSON.stringify(currentState));

			await provider.app.setNewState(getters.objectsState);
			commit('setLoadingState', { type: 'loaded' });

			if (payload.focusAfterUpdate) {
				await dispatch('focus', payload.focusAfterUpdate);
			}
		},
	},
};
